import { useDispatch } from "react-redux";
import * as nodeUtils from "../../../abstract/controller/utils/nodeUtils";
import { handleChoiceCreate } from "../../../abstract/redux/slice/structureSlice";
import IconPlusCircled from "../../../themes/icons/IconPlusCircled";
import DefaultTooltip, * as vendorTooltip from "../../ui/tooltips/DefaultTooltip";
import styles from "./ChoiceOptions.module.scss";

function ChoiceOptions({ id, node, isMouseOver = false, isFolded = false }) {
  const _dispatch = useDispatch();

  const _uuid = nodeUtils.getUUID(node);
  const _isAbstract = nodeUtils.isAbstract(node);

  if (isFolded || !_isAbstract) {
    return null;
  }

  const handleButtonAddChoice = () => {
    _dispatch(handleChoiceCreate(id));
  };

  return (
    <div className={`${styles["options"]} ${isMouseOver ? styles["options--visible"] : ""}`}>
      <div
        role="button"
        className={styles["options__icon"]}
        onClick={handleButtonAddChoice}
        data-tooltip-id={`tooltip-add-children-info-${_uuid}`}
        data-tooltip-delay-show={vendorTooltip.getTimeFast()}>
        <IconPlusCircled />
      </div>
      <DefaultTooltip handle={`tooltip-add-children-info-${_uuid}`}>
        Add children choices
      </DefaultTooltip>
    </div>
  );
}

export default ChoiceOptions;
